import {useLazyQuery, useMutation} from '@apollo/client';
import {notificationMutations, notificationQueries} from 'api';
import {NotificationGetAllRequest, NotificationPaginationResponse, NotificationStatus, ResponseViewModel} from 'models';
import {useEffect, useState} from 'react';

export const useGetAllNotifications = () => {
    const [fetchedNotifications, {data, loading, error}] = useLazyQuery<
        NotificationPaginationResponse,
        NotificationGetAllRequest
    >(notificationQueries.Notifications);

    useEffect(() => {
        if (error) {
            console.error('Error fetching notifications:', error.message);
        }
    }, [error]);

    return {
        fetchedNotifications,
        notificationResponse: data?.notifications,
        notificationLoading: loading,
    };
};

export const useGetUnreadNotificationsCount = () => {
    const [count, setCount] = useState(0);
    const [fetchedUnreadNotificationsCount, {data, loading}] = useLazyQuery<
        {
            notifications: {totalCount: number};
        },
        {userId: string}
    >(notificationQueries.UNREAD_NOTIFICATIONS_COUNT);

    useEffect(() => {
        if (!loading && data) {
            setCount(data.notifications.totalCount);
        }
    }, [data]);

    return {
        fetchedUnreadNotificationsCount,
        unreadNotificationsCount: count,
        unreadNotificationsCountLoading: loading,
    };
};

export const useChangeNotificationsStatus = () => {
    const [changeNotificationsStatus, {data, loading}] = useMutation<
        {
            changeNotificationStatus: ResponseViewModel<string>;
        },
        {ids: string[]; status: NotificationStatus}
    >(notificationMutations.CHANGE_NOTIFICATION_STATUS);

    return {
        changeNotificationsStatus,
        changeNotificationsStatusResponse: data?.changeNotificationStatus,
        changeNotificationsStatusLoading: loading,
    };
};
